import { applySnapshot, Instance, SnapshotIn, SnapshotOut, types } from 'mobx-state-tree';
import { enableStaticRendering } from 'mobx-react';
import React, { createContext, useContext } from 'react';

import { analytics, AnalyticsShow } from '@/utils/analytics';

// eslint-disable-next-line react-hooks/rules-of-hooks
enableStaticRendering(typeof window === 'undefined');

export const Storage = types
    .model('Storage', {
        stage: 'intro',
        transition: false,
        sound: false,
        result: false,
        guide: true,
    })
    .actions((self) => ({
        setStage(stage: 'intro' | 'quiz' | 'outro') {
            self.stage = stage;
            self.result = stage === 'outro';
            if (stage === 'outro') {
                analytics(AnalyticsShow.FinalScreen);
            }
        },
        setTransition(transition: boolean) {
            self.transition = transition;
        },
        setSound(allow: boolean) {
            self.sound = allow;
        },
        finishGuide() {
            self.guide = false;
        },
    }));

export type IStorage = Instance<typeof Storage>;
export type IStorageSnapshotIn = SnapshotIn<typeof Storage>;
export type IStorageSnapshotOut = SnapshotOut<typeof Storage>;
export const StorageContext = createContext<IStorage | null>(null);
export const { Provider } = StorageContext;

let localStorage: IStorage;

export function initializeStorage(snapshot?: IStorageSnapshotIn): IStorage {
    const tempStorage = localStorage ?? Storage.create();

    if (!localStorage && snapshot) {
        applySnapshot(tempStorage, snapshot);
    }

    if (typeof window === 'undefined') {
        return tempStorage;
    }

    if (!localStorage) {
        localStorage = tempStorage;
    }

    return localStorage;
}

export const useStorage = (): IStorage => {
    const store = useContext(StorageContext);
    if (!store) {
        throw Error('store must be initialized');
    }
    return store;
};
